module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACshmLzAAAArElEQVRYCe2U0QmAMAxE1a7RUbqAiziUi7hAR+kaBQ004Qr5SgVRI4htjzyPK9w0+fP3BGYOIOe81lp32ocQtpTSwRp9QY94blgX5C8MaD8neGQjrNEXdDy2rDu+GLCQ7pgRAxTLBSz0tnXHB707N2xUvoHjI57ARxLwJpQieupGxQA0ndpUoI96VfmjUJ/3BN6bgDehFNFTlygGoOnUpgJ91KvKH4X6/HsTOAFyYW8WVZIkFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/area-base/assets/images/listIcon.png
// module id = 6uCw
// module chunks = 222